export default "__VITE_PUBLIC_ASSET__24dd5267__"